import {ActionContext, ActionTree} from 'vuex'
import {mutationType} from './mutation-types'
import UserProfileState, {IUserLine, UserProfile} from './states'
import _ from 'lodash'
import {State} from '@/store/store'
import axios from 'axios'
import httpRequest from '@/services/HttpRequestServiceWithToken'
import HttpRequestServiceWithToken from '@/services/HttpRequestServiceWithToken'

const actions: ActionTree<UserProfileState, State> = {
  async getUserProfile(
    {commit, dispatch, state}: ActionContext<UserProfileState, State>,
    options: {[key: string]: any},
  ): Promise<void> {
    await httpRequest.get(
      process.env.VUE_APP_API_URL + '/v1/authentication',
      options, (res: any) => {
        commit(mutationType.GET_USER_PROFILE, res)
      },
    )
  },
  async setLineId(
    {commit, dispatch, state}: ActionContext<UserProfileState, State>,
    lineId: string,
  ): Promise<void> {
    commit(mutationType.SET_LINE_ID, lineId)
  },
  async setUserLine(
    {commit, dispatch, state}: ActionContext<UserProfileState, State>,
    data: IUserLine,
  ): Promise<void> {
    commit(mutationType.GET_USER_LINE, data)
    this.dispatch('userprofile/getUserProfile', {})
  },
  async setMetadataExcludeDate(
    {commit, dispatch, state}: ActionContext<UserProfileState, State>,
    data: {[key: string]: any},
  ): Promise<void> {
    const id = data._id
    delete data._id
    await HttpRequestServiceWithToken
      .postByLevel(
        process.env.VUE_APP_API_URL + '/v1', `user/${id}/exclude-date/${data.date}`, data, (res: any) => {
        commit(mutationType.SET_USER_META_DATA, data)
      })
  },
  async putUserProfile(
    {commit, dispatch, state}: ActionContext<UserProfileState, State>,
    data: {[key: string]: any},
  ): Promise<void> {
    const id = data._id
    delete data._id
    await HttpRequestServiceWithToken
      .postByLevel(
        process.env.VUE_APP_API_URL + '/v1', `user/${id}`, data, (res: any) => {
        commit(mutationType.PUT_USER, data)
      })
  },
  async removeMetadataExcludeDate(
    {commit, dispatch, state}: ActionContext<UserProfileState, State>,
    data: {[key: string]: any},
  ): Promise<void> {
    const id = data._id
    delete data._id
    await HttpRequestServiceWithToken
      .deleteByLevel(
        process.env.VUE_APP_API_URL + '/v1', `user/${id}/exclude-date/${data.date}`, data, (res: any) => {
        commit(mutationType.REMOVE_USER_META_DATA, data)
      })
  },
}

export default actions
